// eslint-disable-next-line import/no-cycle
import {
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TemplateStructureEnum,
  TabItem,
  BackgroundImageOptionTypeEnum,
  ElementPartTypeEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import {
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
  setBackgroundImage,
  setResponsiveDisplayStack,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getCssPropertyByName,
  getBackgroundImageProperties,
  getBackgroundImageValue,
  isMediaDisplayAlreadyRestricted,
  getResponsiveDisplay,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import getBackgroundImageFieldConfig from '@/components/template-builder/config/fields/background-image-config';
// eslint-disable-next-line import/no-cycle
import { refreshSmartProductList } from '@/components/template-builder/callbacks';
// eslint-disable-next-line import/no-cycle
import { restoreSmartListsOriginalCode } from '@/composables/template-editor/TemplateEditor';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getResponsiveDisplayStackFieldConfig from '@/components/template-builder/config/fields/responsive-display-stack-config';
// eslint-disable-next-line import/no-cycle
import getConditionalSegments from '@/components/template-builder/getters/conditional-display';
// eslint-disable-next-line import/no-cycle
import setConditionalSegments from '@/components/template-builder/setters/conditional-display';
// eslint-disable-next-line import/no-cycle
import conditionalDisplayFieldConfig from '@/components/template-builder/config/fields/conditional-display-config';
// eslint-disable-next-line import/no-cycle
import getLoopField from '@/components/template-builder/config/fields/loop-field-helper';

export const sectionTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.SECTION,
  label: 'templateBuilder.configs.section',
  selector: 'body table#spm_body #{ID} .container',
  tabPanel: {
    label: 'templateBuilder.configs.section',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        items: [
          {
            label: 'templateBuilder.fields.backgroundColorFullWidth',
            selector: 'body table#spm_body #{ID}',
            properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getColorFieldConfig('#ffffff'),
          },
          {
            label: 'templateBuilder.fields.backgroundColorCentralArea',
            selector: 'body table#spm_body #{ID} .container',
            properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getColorFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.backgroundImage',
            selector: 'body table#spm_body #{ID}',
            properties: [
              { name: 'background-image', getter: getBackgroundImageValue, setters: [setBackgroundImage] },
              { name: 'backgroundImageCustomSelector', getter: getBackgroundImageProperties, setters: [] },
            ],
            ...getBackgroundImageFieldConfig(BackgroundImageOptionTypeEnum.SELECTOR),
          },
          {
            label: 'templateBuilder.fields.sectionMargins',
            selector: 'body table#spm_body #{ID} > tbody > tr > td',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            ...getVerticalSpacesFieldConfig('padding'),
          },
          {
            label: 'templateBuilder.fields.bordersBack',
            selector: 'body table#spm_body #{ID}',
            properties: [
              { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-style', getter: getCssPropertyByName, setters: [] },
              { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
            ],
            ...bordersFieldConfig,
            options: {
              ...bordersFieldConfig.options,
              defaultColor: '#000000',
            },
          },
          {
            label: 'templateBuilder.fields.bordersCentralArea',
            selector: 'body table#spm_body #{ID} .container',
            properties: [
              { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-style', getter: getCssPropertyByName, setters: [] },
              { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.responsiveRow',
            selector: 'body table#spm_body #{ID} .row, body table#spm_body #{ID}',
            displayToggle: false,
            properties: [{
              // eslint-disable-next-line max-len
              name: 'spm_responsive', getter: getResponsiveDisplay, setters: [setResponsiveDisplayStack], preCallbacks: [(widgetId: string) => restoreSmartListsOriginalCode(widgetId)], callbacks: [refreshSmartProductList],
            }],
            disableHandler: () => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true',
            disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
            ...getResponsiveDisplayStackFieldConfig('spm_responsive', ''),
          },
          {
            label: 'templateBuilder.fields.mediaDisplay',
            selector: 'body table#spm_body #{ID}',
            properties: [{ name: 'show-for-', getter: getClassByName, setters: [setMediaDisplay] }],
            disableHandler: (selector: string) => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true' || isMediaDisplayAlreadyRestricted(selector),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
            ...mediaDisplayFieldConfig,
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.conditionsAndRepetition',
        items: [
          {
            ...conditionalDisplayFieldConfig,
            label: 'templateBuilder.fields.conditionalDisplay',
            selector: 'body table#spm_body #{ID}',
            properties: [{ name: 's-segments', getter: getConditionalSegments, setters: [setConditionalSegments] }],
          },
          getLoopField('body table#spm_body #{ID}'),
        ],
      },
    ],
  },
};

const sectionItemConfig: ConfigurationPanelStructure = {
  items: [
    sectionTabItemConfig,
  ],
};

export default sectionItemConfig;
